<template lang="pug">
.added-volume
    h2.section-title.pb-1 {{ $t('relatorio_rastreabilidade.messages.traceabilityReport.addedVolume.title') }}
    el-card
        .added-volume__container
            .el-progress-style(style="width: 100%")
                el-progress(
                    :percentage="volumePercentage"
                    :show-text="false"
                    :status="progressStatus"
                )
            .progress-total
                | {{ formatters.formatNumber(volumeAdded) }} / {{ formatters.formatNumber(!maxVolume ? 0 : maxVolume) }}
        span
            span(v-if="maxVolume !== 0")
                i.mr-1(v-if="progressStatus === 'success' || progressStatus === 'warning'" :class="`el-icon-${volumePercentage === 100 ? 'success' : 'warning'}`")
                i.mr-1(v-else class="el-icon-error")
                span(v-if="this.volumeAdded > this.maxVolume")
                    | {{ $t('relatorio_rastreabilidade.messages.traceabilityReport.addedVolume.volumeError') }}
                span(v-else-if="volumePercentage === 100")
                    | {{ $t('relatorio_rastreabilidade.messages.traceabilityReport.addedVolume.volume_completed_tip') }}
                span(v-else)
                    | {{ $t('relatorio_rastreabilidade.messages.traceabilityReport.addedVolume.remaining_volume_to_contract_tip', { volume: formatters.formatNumber(volumeRemaining) }) }}
            span(v-else)
                i(:class="`el-icon-${volumePercentage === 100 ? 'success' : 'warning'}`")
                | {{ $t('relatorio_rastreabilidade.messages.traceabilityReport.addedVolume.volume_contracted_tip') }}
</template>
<script>
import EventBus from '@/utils/eventBus';
import formatters from '@/utils/formatters';

export default {
    name: 'AddedVolumeDefault',
    data() {
        return {
            formatters,
            volumeRemaining: 0,
            volumeAdded: 0,
            volumeLoaded: 0,
            maxVolume: null,
            processedContractVolumes: new Set()
        };
    },
    computed: {
        volumePercentage() {
            if (!this.maxVolume) return 0;
            return Math.min((this.volumeAdded / this.maxVolume) * 100, 100);
        },
        progressStatus() {
            if (this.volumePercentage === 100 && this.volumeAdded <= this.maxVolume) {
                return 'success';
            } else if (this.volumePercentage < 100) {
                return 'warning';
            } else {
                return 'exception';
            }
        }
    },
    created() {
        EventBus.$on('volume-input-updated', this.updateVolumeAdded);
        EventBus.$on('contratos-selecionados', this.updateVolumeContract);
        EventBus.$on('contratos-carregados', this.updateVolumeContractLoaded);
        EventBus.$on('remover-contratos', this.removeVolumeFromContracts);
    },
    methods: {
        updateVolumeAdded(volume) {
            this.maxVolume = volume;
            this.volumeRemaining = this.maxVolume - this.volumeAdded;
        },
        updateVolumeContract(contratos) {
            const newVolume = contratos
                .filter(contrato => !this.processedContractVolumes.has(contrato.id))
                .map(contrato => contrato.volumeSelecionado || 0)
                .reduce((total, volume) => total + volume, 0);

            contratos.forEach(contrato => this.processedContractVolumes.add(contrato.id));

            this.volumeAdded += newVolume;
            this.volumeRemaining = this.maxVolume - this.volumeAdded;
        },
        updateVolumeContractLoaded(totalContractsVolume) {
            const incrementalVolume = totalContractsVolume - this.volumeLoaded;

            this.volumeAdded += incrementalVolume;
            this.volumeLoaded = totalContractsVolume;
            this.volumeRemaining = this.maxVolume - this.volumeAdded;
        },
        removeVolumeFromContracts(contratosExcluidos) {
            const volumeToSubtract = contratosExcluidos
                .map(contrato => contrato.volumeSelecionado || contrato.reportAddedVolume || 0)
                .reduce((total, volume) => total + volume, 0);

            contratosExcluidos.forEach(contrato => this.processedContractVolumes.delete(contrato.id));

            this.volumeAdded = Math.max(0, this.volumeAdded - volumeToSubtract);
            this.volumeRemaining = this.maxVolume - this.volumeAdded;
        }
    }
};

</script>

<style scoped lang="scss">
.added-volume {
    width: 100%;

    .section-title {
        font-size: 16px;
        line-height: 22px;
        font-weight: 500;
        color: var(--primary-font-color);
    }

    .added-volume__container {
        display: flex;
        flex-direction: row;
        gap: 20px;
        justify-content: space-between;
        align-items: center;
    }

    .progress-total {
        text-wrap: nowrap;
    }

    .el-icon-warning {
        color: #f0ad4e;
    }

    .el-icon-success {
        color: #5cb85c;
    }
}
</style>
